import React from 'react';
import './vertical-divider-line.scss';

export const VerticalDividerLine = ({height}) => (
  <div className="vertical-divider-line" style={{height, margin: '0 8px'}}></div>
);
